import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/useBrandGroup'

import { formatEntityCount } from '@functions/entity'

import { BrandGroupModel } from '@models/types'

interface BrandGroupListItemProps {
  brandGroup: BrandGroupModel,
}

const BrandGroupListItem = (props: BrandGroupListItemProps) => {
  const { brandGroup, brandGroup: { id, member_count, title } } = props

  const { editBrandGroupUrl } = generateUrls(brandGroup)
  const { brand } = useRelations(brandGroup)

  return (
    <DashboardModuleListItem
      href={editBrandGroupUrl}
      secondaryText={brand.title}
      title={<Box>{title}&nbsp;<Text color="bodyFontLightColor">#{id}</Text></Box>}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {/*
         // @ts-expect-error TS2322 */}
        {formatEntityCount({ entityCount: member_count, entityString: 'Member' })}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default BrandGroupListItem
